module.exports = __webpack_public_path__ + "media/components/Sponsors/Shared/Icons/monochrome_twitter_icon-79a9f748e7428043550d4b593feba368.png";